<template>
  <div>
    <!-- <LinkBankAccount :companyId="company.id" /> -->
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-7">
            <h4 class="primary-color font-600">
              {{ $t("text.bBankDeposit.title") }}
            </h4>
          </div>
          <div class="col-md-3">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :custom-shortcuts="customShortcuts"
              color="#4b2d73"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>
      </div>
      <section class="section__row mt-3 row ml-0" v-if="!showLoader">
        <div class="w-100 col-md-4 mb-3">
          <div
            class="ep-card p-3"
            style="border-radius: 17px"
            :style="{
              backgroundImage: `url(${cardBackgroundUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right',
              backgroundSize: ' 136px',
            }"
          >
            <div class="card__header___text">
              <div class="w-100">
                <h6 class="primary-color text-center">
                  {{ $t("text.bBankDeposit.amountPaid") }}
                </h6>
                <div class="dealer__icon__wrapper mt-4">
                  <div class="dealer__icon__div text-center">
                    <div>
                      <img src="@/assets/img/wallet.svg" width="35px" />
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <h3 class="text-center primary-color">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ convertThousand(totalAmountPaid) }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 col-md-4 mb-3">
          <div
            class="ep-card p-3"
            style="border-radius: 17px"
            :style="{
              backgroundImage: `url(${cardBackgroundUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right',
              backgroundSize: ' 136px',
            }"
          >
            <div class="card__header___text">
              <div class="w-100">
                <h6 class="primary-color text-center">
                  {{ $t("text.bBankDeposit.amountRaised") }}
                </h6>
                <div class="dealer__icon__wrapper mt-4">
                  <div class="dealer__icon__div text-center">
                    <div>
                      <img src="@/assets/img/wallet.svg" width="35px" />
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <h3 class="text-center primary-color">
                      {{ branch ? branch.currencyCode : ""
                      }}{{ convertThousand(totalAmountRaised) }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 col-md-4 mb-3">
          <div
            class="ep-card p-3"
            style="border-radius: 17px"
            :style="{
              backgroundImage: `url(${cardBackgroundUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right',
              backgroundSize: ' 136px',
            }"
          >
            <div class="card__header___text">
              <div class="w-100">
                <h6 class="primary-color text-center">
                  {{ $t("text.bBankDeposit.difference") }}
                </h6>
                <div class="dealer__icon__wrapper mt-4">
                  <div class="dealer__icon__div text-center">
                    <div>
                      <img src="@/assets/img/wallet.svg" width="35px" />
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <h3 class="text-center primary-color">
                      {{ branch ? branch.currencyCode : ""
                      }}{{ convertThousand(totalAmountDiff) }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="empty-info-wrapper new-row" v-if="transactions.length < 1">
        <img src="@/assets/img/bank-building (2) (2).svg" width="50" />
        <p class="light-grey-text mt-5">
          {{ $t("text.bLinkedBank.noBankLinked") }}
        </p>
        <small class="light-grey-text">{{
          $t("text.bLinkedBank.bankTraDisplayed")
        }}</small>
        <div class="mt-5"></div>
      </div>
      <section class="new-row" v-if="transactions.length > 0">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :allowTextWrap="true"
          :rowDataBound="rowDataBound"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="80" field="index" headerText="#"></e-column>
            <e-column
              width="180"
              :format="formatOptions"
              type="date"
              field="dateCreated"
              :headerText="$t('text.bLinkedBank.dateCreated')"
            ></e-column>
            <e-column
              width="180"
              field="status"
              :headerText="$t('text.form.status')"
            ></e-column>
            <e-column
              width="180"
              field="transactionReference"
              :headerText="$t('text.bLinkedBank.transactionRef')"
            ></e-column>
            <e-column
              width="180"
              field="amount"
              :headerText="`${$t('text.bBankDeposit.amountPaid')} (${
                branch ? branch.currencyCode : ''
              })`"
              format="N2"
            ></e-column>
            <e-column
              width="180"
              field="amountRaised"
              :headerText="`${$t('text.bBankDeposit.amountRaised')} (${
                branch ? branch.currencyCode : ''
              })`"
              format="N2"
            ></e-column>
            <e-column
              width="180"
              field="summary"
              :headerText="$t('text.bLinkedBank.summary')"
              format="N2"
            ></e-column>
            <e-column
              width="180"
              field="bankName"
              :headerText="$t('text.bBankAccounts.bank')"
            ></e-column>
            <e-column
              width="180"
              field="accountName"
              :headerText="$t('text.bBankAccounts.accountName')"
            ></e-column>
            <e-column
              width="180"
              field="accountNumber"
              :headerText="$t('text.bBankAccounts.accountNumber')"
            ></e-column>
            <e-column
              width="180"
              field="linked"
              :headerText="$t('text.bLinkedBank.summary')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader"></TableLoader>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  groupAggregates,
} from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import invoiceTemp from "@/components/Templates/list_of_invoices_template.vue";
import VueMomentsAgo from "vue-moments-ago";
import LinkBankAccount from "@/components/modals/linkBankAccount.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Bank Linked Transactions:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    LinkBankAccount,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      cardBackgroundUrl,
      transactions: [],
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      showLinkedBanks: false,
      banks: [],
      branch: {},
      bankNames: [],
      branchId: null,
      showLoader: true,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      totalAmountRaised: 0,
      totalAmountPaid: 0,
      totalAmountDiff: 0,
      branch: {},
      branchId: null,
    };
  },
  computed: {
    linkedBanks() {
      return this.banks.filter((bank) => bank.linked === true);
    },
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getBankLinkedTransactions();
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getBankLinkedTransactions();
          this.$eventHub.$on("branch", (branch) => {
            this.branch = branch;
          });
        }
      }
    },
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Bank deposits :: ${branch.name} Retail Outlet`;
    });
    document.title = `Bank deposits :: Epump Retail Outlet`;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Banks?companyId=${this.branch.companyId}&branchId=${this.branch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankNames = response.data;
        })
        .catch((error) => {});
    },
    rowDataBound: function (args) {
      if (args.data["status"] === "PENDING") {
        args.row.cells[2].style.color = "red";
      } else {
        args.row.cells[2].style.color = "green";
      }
    },

    getBankLinkedTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankLinkedTransactions/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.transactions = response.data;
          response.data.forEach((el, index) => {
            const amountDiff = el.amount - el.amountRaised;
            const summary =
              amountDiff === 0
                ? "Paid"
                : amountDiff > 0
                ? "Over paid"
                : "Under paid";
            el.summary = el.status === "PENDING" ? "N/A" : summary;
            el.linkedService = el.linkedService ? el.linkedService : "N/A";
            el.index = index + 1;
            el.linked = el.linked ? "Yes" : "No";
          });

          this.totalAmountPaid = response.data.reduce(
            (acc, cur) => (acc += cur.amount),
            0
          );
          this.totalAmountRaised = response.data.reduce(
            (acc, cur) => (acc += cur.amountRaised),
            0
          );

          this.totalAmountDiff = this.totalAmountPaid - this.totalAmountRaised;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
